import { useQuery } from '@tanstack/react-query';
import { catalogService } from '@/services/catalogService';
import { queryKeys } from '@/lib/queryKeys';

export function useCatalogNonBuy() {
  return useQuery({
    queryKey: queryKeys.catalog.nonBuy(),
    queryFn: () => catalogService.listNonBuy(),
    staleTime: 30_000,
  });
}
